import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  href,
  variant = 'primary',
  fullWidth = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-black uppercase tracking-wider transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-xl hover:shadow-2xl rounded-md py-4 px-8 text-lg md:text-xl leading-none text-center';
  const variants = {
    primary: 'bg-[#16a34a] hover:bg-[#15803d] text-white border-b-4 border-[#166534]',
    secondary: 'bg-yellow-400 hover:bg-yellow-500 text-black border-b-4 border-yellow-600'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-38">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-39">
      {children}
    </button>;
}